import { IconButton } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import BlockIcon from '@material-ui/icons/Block';
import CheckIcon from '@material-ui/icons/Check';
import { action, computed, toJS } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { IEntity, INamedEntity } from '../main/entities';
import { commSvc } from '../services/CommSvc';
import { toasterSvc } from '../services/ToasterSvc';
import { getOmnistore } from '../stores/Omnistore';

interface ICombiEntity extends INamedEntity {
	supplierItemId: number
	supplierId: number
	templateItemId?: number
	itemGroup1?: string
	isDeleted: boolean
	isInvalid: boolean
}

interface IAddToCartProps {
	entity: IEntity
}

function findTemplateId(supplierId: number) : number {
	const templateRepo = getOmnistore().multirepo.templateRepo;
	const locationStore = getOmnistore().multirepo.locationStore;
	const template = templateRepo.allAsList.filter(t => t.branchId===locationStore.branchId && t.supplierId===supplierId)[0];
	return template && template.id;
}

@observer class _AddToCart extends React.Component<IAddToCartProps> {
	get entity() {
		return this.props.entity as ICombiEntity; //TODO
	}

	@computed get isBlocked() {
		return this.entity.isDeleted || this.entity.isInvalid;
	}

	@action _onClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
		event.preventDefault();
		event.stopPropagation();
		const entity = this.entity;
		console.log('entity', JSON.stringify(toJS(entity)));
		const {supplierItemId, supplierId, templateItemId, itemGroup1} = entity;
		if (templateItemId) {
			toasterSvc.warning('alreadyInTemplate');
			return;
		}
		if (this.isBlocked) {
			toasterSvc.warning('discontinued');
			return;
		}
		const templateId = findTemplateId(supplierId);
		commSvc.doPost('CreateTemplateItem', {templateId, supplierItemId, category: itemGroup1})
			.then(commSvc.requireOutputObject)
			.then(() => {
				toasterSvc.success('addedToTemplate');
				getOmnistore().multirepo.templateItemRepo(templateId).fetchDirect();
			})
			.catch(toasterSvc.failure);
	}

	render() {
		const {templateItemId} = this.entity;
		return <IconButton style={{color: 'inherit'}} onClick={this._onClick}>
			{templateItemId ? <CheckIcon/> : this.isBlocked ? <BlockIcon/> : <AddShoppingCartIcon/>}
		</IconButton>;
	}
}

const styles = createStyles({
});

export const AddToCart = withStyles(styles)(_AddToCart);
